document.addEventListener('DOMContentLoaded', function() {
    if (typeof jQuery == 'undefined') {
      console.error('jQuery is not loaded. This script requires jQuery.');
      return;
    }
  
    (function($) {
      // A definitive, faithful implementation of the original, working script's logic,
      // adapted to build modern accordion components.
  
      const source = $('#data-sections');
      const accordionContainer = $('#product-accordion-container');
      const productImage = $('.bottom-image__container');
      if (!source.length || !accordionContainer.length) return;
  
      // --- The key insight: Detach all H1 content FIRST ---
      // This removes the H1s and their content from the source, leaving only
      // the H2 "notes" behind. This prevents H1s from ever appearing inside the
      // Olfactive Pyramid.
      const h1Sections = {};
      source.find('h1').each(function() {
        const h1 = $(this);
        const titleText = h1.text().trim().toLowerCase();
        const content = h1.nextUntil('h1');
        
        let key = titleText.replace(/\s+/g, '-');
        if (key === 'bibliography') key = 'bio';
        if (key === 'more-research') key = 'more';
  
        h1Sections[key] = content;
        
        // Detach the h1 and its content so they are no longer in the source
        h1.add(content).detach();
      });
  
      // --- Now, process the remaining H2 sections (Olfactive Notes) ---
      const notesContent = source.clone(); // Clone what's left (only the notes)
      
      // --- Render the content in the correct order ---
      
      // 1. Render the Intro
      if (h1Sections.intro) {
        $('[data-intro]').append(h1Sections.intro);
      }

      // 2. Render the Image
      if (h1Sections.image) {
        productImage.html(h1Sections.image);
      }

      // 2. Define the Accordion Order
      const accordionOrder = [
        { key: 'history', title: 'History', open: true },
        { key: 'notes', title: 'Olfactive pyramid' },
        { key: 'description', title: 'Description' },
        { key: 'more', title: 'More research' },
        { key: 'bio', title: 'Bibliography' },
      ];
  
      // 3. Build and Append Accordions
      accordionOrder.forEach(item => {
        let content = '';
        let isProse = true;
        let hasContent = false;
  
        if (item.key === 'notes') {
          // Build the notes from the cleaned source
          const notesContainer = $('<div class="product-single__notes-content"></div>');
          notesContent.find('h2').each(function() {
            const h2 = $(this);
            const titleText = h2.text().trim();
            const noteBody = h2.nextUntil('h2');
            if (titleText) {
              const noteItem = $(`<div class="product-single__notes-item"><h2>${titleText}</h2></div>`);
              noteItem.append(noteBody);
              notesContainer.append(noteItem);
              hasContent = true;
            }
          });
          content = notesContainer;
          isProse = false;
        } else {
          content = h1Sections[item.key];
          if (content && content.length > 0) {
            hasContent = true;
          }
        }
  
        if (hasContent) {
          const accordion = $(`
            <accordion-disclosure class="accordion">
              <details class="accordion__disclosure" ${item.open ? 'open' : ''}>
                <summary class="accordion__summary">
                  <span>${item.title}</span>
                  <svg aria-hidden="true" focusable="false" width="11" class="icon-accordion-small-arrow" fill="none" viewBox="0 0 11 7">
                    <path stroke="currentColor" stroke-width="1.5" d="M10 1 5.5 5.5 1 1" />
                  </svg>
                </summary>
                <div class="accordion__content ${isProse ? 'prose' : ''}"></div>
              </details>
            </accordion-disclosure>
          `);
          accordion.find('.accordion__content').append(content);
          accordionContainer.append(accordion);
        }
      });
  
    })(jQuery);
  });